export const reveal = 'nx-reveal';

export const buttonBase =
  'inline-flex min-h-12 cursor-pointer items-center justify-center rounded-[var(--nx-radius)] border px-[18px] font-extrabold';

export const button =
  `${buttonBase} border-white bg-white text-[var(--nx-ink)]`;

export const buttonLight = `${buttonBase} border-white bg-transparent text-white`;

export const buttonDarkPrimary =
  `${buttonBase} border-[var(--nx-ink)] bg-[var(--nx-ink)] text-white`;

export const buttonDarkSecondary =
  `${buttonBase} border-[rgba(19,26,43,.38)] bg-[rgba(255,255,255,.2)] text-[var(--nx-ink)]`;

export const buttonOutlineDark =
  `${buttonBase} border-[rgba(16,22,36,.26)] bg-[rgba(255,255,255,.32)] text-[var(--nx-ink)]`;

export const heroActionLink = button;

export const heroActionLinkDark = buttonLight;

export const section =
  `${reveal} relative overflow-hidden px-[clamp(20px,6vw,88px)] py-[clamp(46px,8vw,96px)]`;

export const sectionInner = 'relative z-[1] mx-auto max-w-[1180px]';

export const sectionTitle =
  'mb-[30px] mt-0 text-[clamp(2rem,4vw,3.7rem)] leading-none text-[var(--nx-ink)]';

export const gridThree = 'grid grid-cols-1 gap-[18px] min-[841px]:grid-cols-3';

export const copyBlock = 'grid max-w-[860px] gap-[22px]';

export const copyBlockWide = `${copyBlock} max-w-[980px]`;

export const paragraphMuted = 'm-0 leading-[1.65] text-[var(--nx-muted)]';

export const card =
  `${reveal} block overflow-hidden rounded-[var(--nx-radius)] border border-[var(--nx-line)] bg-white shadow-none transition-[border-color,opacity,transform] duration-[220ms,780ms,220ms] hover:-translate-y-[3px] hover:border-[var(--nx-blue)]`;

export const cardContent = 'block p-7';

export const cardIcon = 'mb-[22px] inline-flex h-[34px] w-[34px] items-center justify-center rounded-[var(--nx-radius)] bg-[var(--nx-blue)] text-white [&_svg]:h-[19px] [&_svg]:w-[19px] [&_svg]:stroke-[2.35]';

export const cardTitle = 'mb-3 mt-0 text-[1.35rem] leading-[1.25] text-[var(--nx-ink)]';

export const cardBody = paragraphMuted;

export const projectGrid = gridThree;

export const sectionActions = 'mt-7 flex flex-wrap gap-3';
